import { html } from 'lit-element';

import { compareState } from '@elab/core/utils/webComponent';

import { FormElement } from './Form';

export class FieldError extends FormElement {
    static get properties() {
        return {
            customLabel: {
                type: Boolean,
                attribute: 'use-custom-label',
            },
        };
    }

    shouldUpdate(changedProps) {
        return [['customLabel'], ['fieldValue', 'error']].some(item =>
            compareState(this, changedProps, ...item),
        );
    }

    render() {
        const error = this.fieldValue && this.fieldValue.error;
        return error
            ? html`
                  <span class="text form-field-error">
                      ${this.customLabel
                          ? html`
                                <v-slot></v-slot>
                            `
                          : error}
                  </span>
              `
            : html``;
    }
}

export default () => customElements.define('e2-field-error', FieldError);
